import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
 const Misc = (props) => (
   <SvgIcon {...props}>
      <g>
        
          <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
          21.36,17.4 12,21 12,9.462 21.36,6.24 	"/>
        
          <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
          2.64,17.4 12,21 12,9.462 2.64,6.24 	"/>
        <g>
          <path fill="#282525" d="M18.12,7.662v6.174l-2.16,0.742V8.432L6.308,5.11L8.792,3.68l9.965,3.431
            C19.193,7.259,18.12,7.201,18.12,7.662z"/>
        </g>
        
          <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
          2.64,6.24 12,9.462 21.36,6.24 12,3 	"/>
      </g>
   </SvgIcon>
);

export default Misc;



// WEBPACK FOOTER //
// ./src/icons/types/Misc.jsx